function initPriceSlider(){var e=document.querySelectorAll(".range-slider");e&&e.forEach((function(e){var a=e.querySelectorAll("input[type=range]"),l=e.querySelectorAll("input[type=number]");a.forEach((function(e){e.oninput=function(){var e=parseFloat(a[0].value),u=parseFloat(a[1].value);e>u&&([e,u]=[u,e]),l[0].value=e,l[1].value=u}})),l.forEach((function(e){e.oninput=function(){var e=parseFloat(l[0].value),u=parseFloat(l[1].value);if(e>u){var r=e;l[0].value=u,l[1].value=r}a[0].value=e,a[1].value=u}}))}))}
var waitForJQueryAvalancheScripts = setInterval(function () {
    if (typeof $ != 'undefined' && typeof $().slick != 'undefined') {      
      function uspSlides(){
    $('.upsell-products-mobile').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: $(this).data('arrows'),
        infinite: true,
        prevArrow: '<div class="usp-prev"></div>',
        nextArrow: '<div class="usp-next"></div>'
    });
    } uspSlides();
    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', function () {
            if (event.detail.sectionId === '') {
                uspSlides();
            }
        });
    }

    /* Product Card Swatches */
    function cardSwatches() {
      let swatchItems = document.querySelectorAll("label.color__swatch");
      if (swatchItems.length > 0) {
        swatchItems.forEach((swatch) => {
          swatch.addEventListener('mouseenter', enterSwatch);
          swatch.addEventListener('mouseleave', leaveSwatch);
        });

        function enterSwatch(event) {
          let swatch = event.target;
          let swatchColor = swatch.dataset.color;
          let cardWrapper = swatch.closest(".card-wrapper");
          let swatchImage = cardWrapper.querySelector('[src*=' + swatchColor + ']');
          swatchImage.classList.add("hovered");
        }

        function leaveSwatch(event) {
          let swatch = event.target;
          let cardWrapper = swatch.closest(".card-wrapper");
          let hoveredSwatchImage = cardWrapper.querySelectorAll(".hovered");
          hoveredSwatchImage.forEach((image) => {
            image.classList.remove("hovered");
          });
        }
      }
    }

    cardSwatches();
      
      /* Sliders */
      let snowSliders = $(".snow-slider");

      snowSliders.each(function(index) {
        initSlider($(snowSliders[index]));
      });
      function initSlider(slider) {
        let data = slider.data("slick");
        $(slider).on('init', function(slick){
            let clonedSlides = $(slider).find(".slick-cloned");
            let initialSlide = $(slider).find(".slick-current.slick-active");
            if (clonedSlides.length > 0 && initialSlide.length > 0) {
            clonedSlides.each(function(index) {
              $(this).height(initialSlide.height() + "px");
            });
            } 
        });
        $(slider).on('breakpoint', function(event, slick, breakpoint){
          setTimeout(function() {
            let clonedSlides = $(slider).find(".slick-cloned");
            let initialSlide = $(slider).find(".slick-current.slick-active");
            if (clonedSlides.length > 0 && initialSlide.length > 0) {
            clonedSlides.each(function(index) {
              $(this).height(initialSlide.height() + "px");
            });
            } 
          }, "250");
          
        });
        slider.slick(data).on("lazyLoaded", function(event, slick, image, imageSource) {
          image.parents(".snow-slide-background").find(".loading-overlay").addClass("hidden");
        });
      }

       /* Featured Collection Carousels */
      let featuredCollectionSliders = $(".product-carousel");
      function initFeaturedCarousels(slider) {
        let data = slider.data("slick");
        slider.slick(data).on("lazyLoaded", function(event, slick, image, imageSource) {
         image.css("opacity", 1);
          if (image.is(':first-child')) {
            //image.css("opacity", 1);
          }
          image.parents(".card__inner").find(".loading-overlay").addClass("hidden");
        });
      }

       featuredCollectionSliders.each(function(index) {
        initFeaturedCarousels($(featuredCollectionSliders[index]));
         
      });
      
     

    $("a:not(.snowBlockLink, .quick-view, .csb-link, .same-tab-link, .logout-link, .section--contact-information, .learn-more-edd, .edd-exceptions)").attr("target",(function(){return this.host==location.host?"_self":"_blank"})),$("#ageTermsCheck").change((function(){$("#submit_birthdate").prop("disabled",!this.checked)})),$("#ageTermsCheck").click((function(){$(this).is(":checked")?$("#submit_birthdate").css("opacity",1):$("#submit_birthdate").css("opacity",.1)})),$(".header__icon--menu").click((function(){$("body").toggleClass("locked")})),$(".full-height-close.header__icon--menu").click((function(){$(".header__icon.header__icon--menu.mobile").toggleClass("open")})),$(".mega-menu-item").hasClass("blank")||$(this).find("span svg:not(.slide-panel-inner-container span svg)").css("display","inline-block"),$(".mega-menu-item").hover((function(){$(this).hasClass("blank")||($(this).addClass("active"),$(".header-mm-overlay").show())}),(function(){$(this).removeClass("active"),$(".header-mm-overlay").hide()}));

    /* Search Auto-Focus */
    
        $('.header__icon--search').click(function (){
            $(".search__input").focus();
        });
     
      
    function searchLayout(){
    $('.header__icon--search').click(function(){
      $('html').toggleClass('overflow-hidden');
        
        $('.search-slideout').slideToggle(function() {
          document.getElementById("Search-In-Modal-1").focus();
        });
      
        $('.search-overlay').fadeIn(500);
    });

    $('.modal-overlay, .search-modal__content .modal__close-button').click(function (){
      $('body, html').removeClass('overflow-hidden');
    });
    
    $('.search-overlay-close').click(function (){
        $('.search-overlay').fadeOut(500);
    });

    
    }
    searchLayout(); 
    
    if (Shopify.designMode){
      document.addEventListener('shopify:section:load', function(){
          if(event.detail.sectionId === '') {
              searchLayout();
          }
      });
    }

    let backToTop2=$("#backToTop");$(window).scrollTop()>300&&backToTop2.removeClass("hidden"),$(window).on("scroll",(()=>{$(window).scrollTop()<300?backToTop2.fadeOut(500,(()=>{backToTop2.addClass("hidden")})):(backToTop2.fadeIn(500),backToTop2.removeClass("hidden"))})),backToTop2.on("click",(()=>{$("html, body").animate({scrollTop:0},"300")})),$(".disclosure-has-dropdown .facets__summary").on("click",(function(){$(this).toggleClass("active")})),0==$(".collection-sidebar-container .facets-container .facets__wrapper").find(".disclosure-has-dropdown").length&&($(".collection-sidebar-container .facets-container").hide(),$(".collection-sidebar-container #ProductGridContainer .collection.page-width").css({padding:"0"})),initPriceSlider();

    /* Window Resize */
    let mobileBreakpoint = "1335px";
    $(window).resize(function() {
      if ($(window).width() <= mobileBreakpoint) {
        $('.header__icon--menu').removeClass('open');
      }
    });

    

     if ($(".left-mobile-facets").length > 0) {
         $(".left-mobile-facets").on('click', function() {
             $(".mobile-facets__disclosure.disclosure-has-popup.menu-opening").removeClass("menu-opening").removeAttr("open");
             $("summary.mobile-facets__open-wrapper").removeAttr("aria-expanded");
         });
     }

      /* NSFW cookie */
      if (document.cookie.indexOf('isAnAdult') > -1 ) {
        console.log("Adult content available");
        $('.grid__item').removeClass('nsfw');
      }

      /* PDP Dropdown */
      $('.button-dropdown-container label').click(function(){
        $('.form__label.dropdown').removeClass('open');
      });

      //Cart Drawer
     function cartDrawer(){
    $('.product-form__submit, .header__icon--cart, #cart-icon-bubble-mobile').click(function(event){
      if ($(event.currentTarget).hasClass("header__icon--cart")) {
        event.preventDefault();
      }
      
      $('#shopify-section-cart-drawer .my-cart, .cart-close-button, .cart-drawer-overlay').addClass("open");
        window.postMessage({ type: 'cart_drawer', action: "open"}, '*');
    });
    $(document).on('click', '.cart-drawer-overlay, .cart-close-button', function(){
      $('#shopify-section-cart-drawer .my-cart, .cart-close-button, .cart-drawer-overlay').removeClass("open");
      console.log("Close");
        window.postMessage({ type: 'cart_drawer', action: "close"}, '*');
    });
  }
  cartDrawer();

     /* Window Message Handling */
     function windowMessaging() {
     window.addEventListener('message', function(m) {
         if (m.data.type == 'cart_drawer') {
             if (m.data.action == 'open') {
                 if (!$("body").hasClass("locked")) {
                     $("body").addClass("locked");
                 }
               }
             else if (m.data.action == 'close') {
                 if ($("body").hasClass("locked")) {
                     $("body").removeClass("locked");
                 }
             }
         }
         
       });
     };
     windowMessaging();

     if (Shopify.designMode){
         document.addEventListener('shopify:section:load', function(){
             if(event.detail.sectionId === '') {
                 windowMessaging();
             }
         });
     }
clearInterval(waitForJQueryAvalancheScripts);
    }
}, 10);